// Mapping of source names to documentation pages

// CloudSourceAPI documentation links
export const CloudAPILinks = {
  one_password:
    '/2_main-menu/log/cloud_sources_registration/pondurance-one-password-manual',
  addigy:
    '/2_main-menu/log/cloud_sources_registration/pondurance-addigy-manual',
  aws_cloudtrail:
    '/2_main-menu/log/cloud_sources_registration/pondurance-aws-cloudtrail-manual',
  aws_s3: '/2_main-menu/log/cloud_streaming_storage_sources/aws_s3_stream',
  aws_security_hub:
    '/2_main-menu/log/cloud_sources_registration/pondurance-aws-security-hub-manual',
  abnormal_security:
    '/2_main-menu/log/cloud_sources_registration/pondurance-abnormal-security-manual',
  action1:
    '/2_main-menu/log/cloud_sources_registration/pondurance-action1-manual',
  azure_event_hub:
    '/2_main-menu/log/cloud_streaming_storage_sources/azure_eventhub_stream',
  azure_virtual_network_flow_logs:
    '/2_main-menu/log/cloud_sources_registration/pondurance-azure-virtual-network-flow-logs-manual',
  carbon_black:
    '/2_main-menu/log/cloud_sources_registration/pondurance-carbon-black-manual',
  check_point:
    '/2_main-menu/log/cloud_sources_registration/pondurance-check-point-manual',
  cisco_duo:
    '/2_main-menu/log/cloud_sources_registration/pondurance-cisco-duo-manual',
  cisco_meraki:
    '/2_main-menu/log/cloud_sources_registration/pondurance-cisco-meraki-manual',
  cisco_secure_endpoint:
    '/2_main-menu/log/cloud_sources_registration/pondurance-cisco-secure-endpoint-manual',
  crowd_strike:
    '/2_main-menu/log/cloud_sources_registration/pondurance-crowd-strike-manual',
  crowd_strike_siem_cases:
    '/2_main-menu/log/cloud_sources_registration/pondurance-crowd-strike-siem-cases-manual',
  dropbox:
    '/2_main-menu/log/cloud_sources_registration/pondurance-dropbox-manual',
  google_storage_gcp:
    '/2_main-menu/log/cloud_streaming_storage_sources/google_cloud_storage_stream',
  google_workspace:
    '/2_main-menu/log/cloud_sources_registration/pondurance-google-workspace-manual',
  imperva_cloud_waf:
    '/2_main-menu/log/cloud_sources_registration/pondurance-imperva-cloud-waf-manual',
  it_glue:
    '/2_main-menu/log/cloud_sources_registration/pondurance-it-glue-manual',
  jumpcloud:
    '/2_main-menu/log/cloud_sources_registration/pondurance-jumpcloud-manual',
  juniper_mist:
    '/2_main-menu/log/cloud_sources_registration/pondurance-juniper-mist-manual',
  logmein_central:
    '/2_main-menu/log/cloud_sources_registration/pondurance-logmein-central-manual',
  medigate:
    '/2_main-menu/log/cloud_sources_registration/pondurance-medigate-manual',
  microsoft:
    '/2_main-menu/log/cloud_sources_registration/pondurance-microsoft-manual',
  microsoft_sentinel:
    '/2_main-menu/log/cloud_sources_registration/pondurance-microsoft-sentinel-manual',
  mimecast:
    '/2_main-menu/log/cloud_sources_registration/pondurance-mimecast-manual',
  mulesoft:
    '/2_main-menu/log/cloud_sources_registration/pondurance-mulesoft-manual',
  net_suite:
    '/2_main-menu/log/cloud_sources_registration/pondurance-net-suite-manual',
  okta: '/2_main-menu/log/cloud_sources_registration/pondurance-okta-manual',
  palo_alto_cortex_xdr:
    '/2_main-menu/log/cloud_sources_registration/pondurance-palo-alto-cortex-xdr-manual',
  proofpoint_essentials:
    '/2_main-menu/log/cloud_sources_registration/pondurance-proofpoint-essentials-manual',
  proofpoint_pod:
    '/2_main-menu/log/cloud_sources_registration/pondurance-proofpoint-pod-manual',
  proofpoint_tap:
    '/2_main-menu/log/cloud_sources_registration/pondurance-proofpoint-tap-manual',
  qualys:
    '/2_main-menu/log/cloud_sources_registration/pondurance-qualys-manual',
  salesforce:
    '/2_main-menu/log/cloud_sources_registration/pondurance-salesforce-manual',
  sentinelone:
    '/2_main-menu/log/cloud_sources_registration/pondurance-sentinelone-manual',
  snowflake:
    '/2_main-menu/log/cloud_sources_registration/pondurance-snowflake-manual',
  sophos_edr:
    '/2_main-menu/log/cloud_sources_registration/pondurance-sophos-edr-manual',
  thinkst_canary:
    '/2_main-menu/log/cloud_sources_registration/pondurance-thinkst-canary-manual',
  threat_locker:
    '/2_main-menu/log/cloud_sources_registration/pondurance-threat-locker-manual',
  trellix:
    '/2_main-menu/log/cloud_sources_registration/pondurance-trellix-manual',
  github:
    '/2_main-menu/log/cloud_sources_registration/pondurance-github-manual',
  ninjaone:
    '/2_main-menu/log/cloud_sources_registration/pondurance-ninjaone-manual',
  acronis:
    '/2_main-menu/log/cloud_sources_registration/pondurance-acronis-manual',
  google_pub_sub:
    '/2_main-menu/log/cloud_sources_registration/pondurance-google-pub-sub-manual',
  files_dot_com:
    '/2_main-menu/log/cloud_sources_registration/pondurance-files-dot-com-manual',
  rubrik: '/2_main-menu/log/cloud_sources_registration/pondurance-rubrik-manual'
} as const;

// Log-Forwarder documentation links (to be populated as they become available)
export const logForwarderLinks = {
  zscaler_zia:
    '/2_main-menu/log/log_forwarding_instructions/pondurance-zscaler-zia-manual/'
} as const;
